import { Pipe, PipeTransform } from '@angular/core';

import { enclosuresFieldHeightIsSmallerThenMin } from '../../enclosure/helpers/prisma.helper';
import { EnclosureTabType } from '../../shared/models/project.model';

@Pipe({
    name: 'zoomOutUnavailable',
    standalone: false
})
export class ZoomOutUnavailablePipe implements PipeTransform {

  transform(zoomLevel: number,
            enclosureConfigurationRows: number,
            enclosureConfigurationFields: number,
            maxRows: number,
            maxFields: number,
            mainContent: HTMLElement,
            tab: EnclosureTabType): boolean {
    if (!mainContent || tab !== EnclosureTabType.CONFIGURATION) {
      return false;
    }
    return enclosuresFieldHeightIsSmallerThenMin(mainContent,
      zoomLevel,
      enclosureConfigurationRows,
      enclosureConfigurationFields,
      maxRows,
      maxFields);
  }
}
